export default "./media/marker_activated-5833bda115a29b510a2510e11bcaea60.png";